import { Box, Grid, Typography } from "@mui/material";

import { ButtonBasic } from "@/Components/v2/atoms/Button/ButtonBasic";

import Welcome from "./Welcome";

type EmptyChatProps = {
  onAskQuestion: (question: string, warcEnabled: boolean) => void;
  warcEnabledForTier: boolean;
};

const SampleQuestions = [
  "What is the current ROI of my marketing spend?",
  "What is my best performing channel?",
  "What is my worst performing channel?",
];

export const EmptyChat = ({ onAskQuestion, warcEnabledForTier }: EmptyChatProps) => {
  return (
    <Box>
      <Welcome mb={3} />
      <Grid container spacing={3} mb={3}>
        {SampleQuestions.map((question, index) => (
          <Grid item xs={12} md={4} key={index}>
            <ButtonBasic
              sx={{
                textAlign: "left",
              }}
              key={index}
              onClick={() => onAskQuestion(question, warcEnabledForTier)}
              fullWidth
              color="secondary"
              variant="contained"
            >
              {question}
            </ButtonBasic>
          </Grid>
        ))}
      </Grid>
      <Typography display="block">Or, try entering your own question below.</Typography>
    </Box>
  );
};
